module.exports = __webpack_public_path__ + "static/media/rede-protecao-1.7c03de09.jpeg";